export function ScoreBar({ score, label }: { score: number; label: string }) {
  return (
    <div style={{ marginBottom: 6 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: 12,
          color: "#555",
          marginBottom: 2,
        }}
      >
        <span>{label}</span>
        <span>{Math.round(score * 100)}%</span>
      </div>
      <div
        style={{
          height: 6,
          background: "#e8eaf0",
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${score * 100}%`,
            background:
              score >= 0.8 ? "#2f9e44" : score >= 0.5 ? "#e67700" : "#c92a2a",
            borderRadius: 3,
          }}
        />
      </div>
    </div>
  );
}
